import React, { useState, useEffect } from "react";
import { UserContext } from "./UserContext";

export const UserProvider = ({ children }) => {
  let loggedInUserDetails = {};
  const user = JSON.parse(window.sessionStorage.getItem("user"));
  if (user) {
    loggedInUserDetails = {
      userName: user.userName,
      roleId: user.roleId,
      id: user.id,
    };
  }
  const [userDetails, setUserDetails] = useState(loggedInUserDetails);

  return (
    <UserContext.Provider value={{ userDetails, setUserDetails }}>
      {children}
    </UserContext.Provider>
  );
};
